<template>
  <div class="person-wrap">
    <div class="person-wraper">
      <el-form
        class="person-form"
        :inline="true"
        ref="personForm"
        :model="personForm"
        label-width="100px"
        :rules="rules"
        :disabled="isDisabled"
      >
        <!-- 主页照片区域 -->
        <div class="person-form-photo">
          <!-- 左边区域内容 -->
          <div class="left-content">
            <el-form-item prop="name">
              <span slot="label">
                姓名
                <!-- <el-tooltip class="item" effect="dark" content="姓名不可修改额" placement="top">
                  <i class="el-icon-s-opportunity"></i>
                </el-tooltip> -->
              </span>

              <el-input v-model="personForm.name" :maxlength="120"></el-input>
            </el-form-item>
            <el-form-item label="曾用名" prop="formername">
              <el-input
                v-model="personForm.formername"
                :maxlength="120"
              ></el-input>
            </el-form-item>

            <el-form-item label="性别" prop="sex">
              <el-select v-model="personForm.sex">
                <el-option label="男" value="男"></el-option>
                <el-option label="女" value="女"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="民族" prop="national">
              <el-select v-model="personForm.national">
                <el-option
                  v-for="item in nationList"
                  :key="item.oid"
                  :label="item.name"
                  :value="item.oid"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出生日期" prop="birthdate">
              <el-date-picker
                v-model="personForm.birthdate"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="年龄" prop="age">
              <el-input v-model="personForm.age" :maxlength="3"></el-input>
            </el-form-item>

            <el-form-item label="联系电话" prop="tel">
              <el-input v-model="personForm.tel" :maxlength="120"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="id">
              <el-input
                v-model="personForm.id"
                v-on:input="personForm_id_input"
                :maxlength="120"
                :disabled="true"
              >
              </el-input>
            </el-form-item>
          </div>
          <!-- 右边图片 -->
          <div class="right-avatar">
            <div class="right-avatar-wrap">
              <div class="avatar-wrap">
                <!--  -->
                <img :src="avatarUploadPreview" class="avatar-preview" alt="" />
              </div>

              <div class="option">
                <el-button
                  type="primary"
                  size="mini"
                  :disabled="isDisabled"
                  @click="avatarUpload('photo')"
                  >上传<i class="el-icon-upload el-icon--right"></i>
                </el-button>
                <input
                  type="file"
                  ref="photoFile"
                  style="display: none"
                  @change="avatarUploadFile('photo')"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="resume-img">
          <div
            v-on:mouseover="mouseoverImg('idfile')"
            v-on:mouseout="mouseoutImg('idfile')"
            class="imgcontent"
          >
            <div @click="avatarUpload('idfile')" class="imgspan">
              <span
                ref="idfileAdd"
                disable
                style="
                  -webkit-user-select: none;
                  user-select: none;
                  display: inline-block;
                  position: absolute;
                  height: 90px;
                  line-height: 90px;
                  left: 135px;
                  top: 50px;
                  font-size: 80px;
                  font-family: '黑体';
                  color: #cccccc;
                "
              >
                +
              </span>
              <span
                ref="idfileExp"
                style="
                  -webkit-user-select: none;
                  user-select: none;
                  display: inline-block;
                  position: absolute;
                  height: 40px;
                  line-height: 40px;
                  left: 80px;
                  top: 120px;
                  font-size: 30px;
                  font-family: '黑体';
                  color: #409eff;
                "
              >
                身份证正面</span
              >

              <img ref="idfileImg" style="display: none" :src="idfileView" />
            </div>
            <div ref="idfileDelete" class="delete-img">
              <i class="el-icon-delete" @click="deleteImg('idfile')"></i>
            </div>
          </div>
          <input
            type="file"
            ref="idfileFile"
            style="display: none"
            @change="avatarUploadFile('idfile')"
          />
        </div>
        <div class="resume-img">
          <div
            v-on:mouseover="mouseoverImg('idbackfile')"
            v-on:mouseout="mouseoutImg('idbackfile')"
            class="imgcontent"
          >
            <div @click="avatarUpload('idbackfile')" class="imgspan">
              <span
                ref="idbackfileAdd"
                disable
                style="
                  -webkit-user-select: none;
                  user-select: none;
                  display: inline-block;
                  position: absolute;
                  height: 90px;
                  line-height: 90px;
                  left: 135px;
                  top: 50px;
                  font-size: 80px;
                  font-family: '黑体';
                  color: #cccccc;
                "
              >
                +
              </span>
              <span
                ref="idbackfileExp"
                style="
                  -webkit-user-select: none;
                  user-select: none;
                  display: inline-block;
                  position: absolute;
                  height: 40px;
                  line-height: 40px;
                  left: 80px;
                  top: 120px;
                  font-size: 30px;
                  font-family: '黑体';
                  color: #409eff;
                "
                >身份证反面</span
              >
              <img
                ref="idbackfileImg"
                style="display: none"
                :src="idbackfileView"
              />
            </div>
            <div ref="idbackfileDelete" class="delete-img">
              <i class="el-icon-delete" @click="deleteImg('idbackfile')"></i>
            </div>
          </div>
          <input
            type="file"
            ref="idbackfileFile"
            style="display: none"
            @change="avatarUploadFile('idbackfile')"
          />
        </div>
        <!-- 其他需要填的信息 -->
        <div class="person-form-items">
          <div class="form-item">
            <el-form-item label="籍贯" prop="hometown" style="width: 470px">
              <el-cascader
                :showAllLevels="false"
                separator
                style="width: 370px"
                v-model="personForm.hometown"
                :options="homeDownData"
              />
            </el-form-item>

            <el-form-item label="电子邮箱" prop="email" style="width: 470px">
              <el-input
                v-model="personForm.email"
                style="width: 370px"
                :maxlength="120"
              ></el-input>
            </el-form-item>
          </div>

          <div class="form-item">
            <el-form-item
              label="最高学历"
              prop="education"
              style="width: 470px"
            >
              <el-select v-model="personForm.education" style="width: 370px">
                <el-option
                  v-for="item in eduList"
                  :key="item.oid"
                  :label="item.name"
                  :value="item.oid"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="证件编号"
              prop="eduno"
              style="width: 470px"
              :rules="
                isEdunoEnable(personForm.education)
                  ? rules.eduno
                  : [{ required: false }]
              "
            >
              <el-input
                v-model="personForm.eduno"
                :maxlength="50"
                style="width: 370px"
              ></el-input>
            </el-form-item>
          </div>

          <div class="form-item">
            <el-form-item
              label="居住地址"
              prop="birthaddr"
              style="width: 960px"
            >
              <el-input
                type="textarea"
                :rows="2"
                v-model="personForm.birthaddr"
                style="width: 850px"
                :maxlength="120"
                showWordLimit
              ></el-input>
            </el-form-item>
          </div>

          <div class="form-item">
            <el-form-item label="政治面貌" prop="polity">
              <el-select v-model="personForm.polity">
                <el-option
                  v-for="item in polityList"
                  :key="item.oid"
                  :label="item.name"
                  :value="item.oid"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="入党(团)时间" prop="partytime">
              <el-date-picker
                v-model="personForm.partytime"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="健康状况" prop="health">
              <el-select v-model="personForm.health">
                <el-option
                  v-for="item in healthList"
                  :key="item.oid"
                  :label="item.name"
                  :value="item.oid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="form-item">
            <el-form-item label="参加工作时间" prop="worktime">
              <el-date-picker
                v-model="personForm.worktime"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="参加工作地点" prop="workaddr">
              <el-input
                v-model="personForm.workaddr"
                :maxlength="120"
              ></el-input>
            </el-form-item>

            <el-form-item label="服从调剂" prop="isobey">
              <el-select v-model="personForm.isobey">
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
          </div>
<!-- 
          <div class="form-item">
            <el-form-item
              label="现工作单位"
              prop="workcorp"
              style="width: 960px"
            >
              <el-input
                type="textarea"
                :rows="2"
                v-model="personForm.workcorp"
                style="width: 850px"
                :maxlength="120"
                showWordLimit
              ></el-input>
            </el-form-item>
          </div>

          <div class="form-item">
            <el-form-item
              label="现职务/岗位"
              prop="workpost"
              style="width: 470px"
            >
              <el-input
                v-model="personForm.workpost"
                style="width: 370px"
                :maxlength="120"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="现任职时间"
              style="width: 470px"
              prop="workdate"
            >
              <el-date-picker
                v-model="personForm.workdate"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 370px"
              >
              </el-date-picker>
            </el-form-item>
          </div> -->

          <div class="form-item">
            <el-form-item label="在校平均成绩" prop="schoolscore">
              <el-input
                v-model="personForm.schoolscore"
                :maxlength="120"
              ></el-input>
            </el-form-item>
            <el-form-item label="有不及格学科" prop="iscoursefail">
              <el-select v-model="personForm.iscoursefail">
                <el-option label="请选择..." value=""></el-option>
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专业特长" prop="specskill">
              <el-input
                v-model="personForm.specskill"
                :maxlength="120"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item label="技术技能等级" prop="skilllevel">
              <el-select v-model="personForm.skilllevel" :maxlength="120">
                <el-option
                  v-for="item in skilllevelList"
                  :key="item.oid"
                  :label="item.name"
                  :value="item.oid"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专业职称" prop="techtitle">
              <el-input
                v-model="personForm.techtitle"
                :maxlength="120"
                placeholder="如没有则无需填写"
              ></el-input>
            </el-form-item>
            <el-form-item label="执业资格" prop="postcerti">
              <el-input
                v-model="personForm.postcerti"
                :maxlength="120"
                placeholder="如没有则无需填写"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item
              label="取得时间"
              prop="gradetime"
              :rules="
                isFieldEnable('techgradetime', personForm.skilllevel)
                  ? rules.gradetime
                  : [{ required: false }]
              "
            >
              <el-date-picker
                v-model="personForm.gradetime"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="取得时间"
              prop="titletime"
              :rules="
                isFieldEnable('techtitletime', personForm.techtitle)
                  ? rules.titletime
                  : [{ required: false }]
              "
            >
              <el-date-picker
                v-model="personForm.titletime"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="取得时间"
              prop="certitime"
              :rules="
                isFieldEnable('postcertitime', personForm.postcerti)
                  ? rules.certitime
                  : [{ required: false }]
              "
            >
              <el-date-picker
                v-model="personForm.certitime"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item
              label="批准文号"
              prop="gradeno"
              :rules="
                isFieldEnable('techgradeno', personForm.skilllevel)
                  ? rules.gradeno
                  : [{ required: false }]
              "
            >
              <el-input
                v-model="personForm.gradeno"
                :maxlength="120"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="批准文号"
              prop="titleno"
              :rules="
                isFieldEnable('techtitleno', personForm.techtitle)
                  ? rules.titleno
                  : [{ required: false }]
              "
            >
              <el-input
                v-model="personForm.titleno"
                :maxlength="120"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="证书编号"
              prop="certino"
              :rules="
                isFieldEnable('postcertino', personForm.postcerti)
                  ? rules.certino
                  : [{ required: false }]
              "
            >
              <el-input
                v-model="personForm.certino"
                :maxlength="120"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-item">
            <div class="resume-img">
              <div
                v-on:mouseover="mouseoverImg('gradefile')"
                v-on:mouseout="mouseoutImg('gradefile')"
                class="imgcontent"
              >
                <div @click="avatarUpload('gradefile')" class="imgspan">
                  <span
                    ref="gradefileAdd"
                    disable
                    style="
                      -webkit-user-select: none;
                      user-select: none;
                      display: inline-block;
                      position: absolute;
                      height: 90px;
                      line-height: 90px;
                      left: 135px;
                      top: 50px;
                      font-size: 80px;
                      font-family: '黑体';
                      color: #cccccc;
                    "
                  >
                    +
                  </span>
                  <span
                    ref="gradefileExp"
                    style="
                      -webkit-user-select: none;
                      user-select: none;
                      display: inline-block;
                      position: absolute;
                      height: 40px;
                      line-height: 40px;
                      left: 64px;
                      top: 120px;
                      font-size: 30px;
                      font-family: '黑体';
                      color: #409eff;
                    "
                  >
                    技术技能等级</span
                  >
                  <img
                    ref="gradefileImg"
                    style="display: none"
                    :src="gradefileView"
                  />
                </div>
                <div ref="gradefileDelete" class="delete-img">
                  <i class="el-icon-delete" @click="deleteImg('gradefile')"></i>
                </div>
              </div>
              <input
                type="file"
                ref="gradefileFile"
                style="display: none"
                @change="avatarUploadFile('gradefile')"
              />
            </div>
            <div class="resume-img">
              <div
                v-on:mouseover="mouseoverImg('titlefile')"
                v-on:mouseout="mouseoutImg('titlefile')"
                class="imgcontent"
              >
                <div @click="avatarUpload('titlefile')" class="imgspan">
                  <span
                    ref="titlefileAdd"
                    disable
                    style="
                      -webkit-user-select: none;
                      user-select: none;
                      display: inline-block;
                      position: absolute;
                      height: 90px;
                      line-height: 90px;
                      left: 135px;
                      top: 50px;
                      font-size: 80px;
                      font-family: '黑体';
                      color: #cccccc;
                    "
                  >
                    +
                  </span>
                  <span
                    ref="titlefileExp"
                    style="
                      -webkit-user-select: none;
                      user-select: none;
                      display: inline-block;
                      position: absolute;
                      height: 40px;
                      line-height: 40px;
                      left: 95px;
                      top: 120px;
                      font-size: 30px;
                      font-family: '黑体';
                      color: #409eff;
                    "
                  >
                    职称证书</span
                  >
                  <img
                    ref="titlefileImg"
                    style="display: none"
                    :src="titlefileView"
                  />
                </div>
                <div ref="titlefileDelete" class="delete-img">
                  <i class="el-icon-delete" @click="deleteImg('titlefile')"></i>
                </div>
              </div>
              <input
                type="file"
                ref="titlefileFile"
                style="display: none"
                @change="avatarUploadFile('titlefile')"
              />
            </div>
            <div class="resume-img">
              <div
                v-on:mouseover="mouseoverImg('postfile')"
                v-on:mouseout="mouseoutImg('postfile')"
                class="imgcontent"
              >
                <div @click="avatarUpload('postfile')" class="imgspan">
                  <span
                    ref="postfileAdd"
                    disable
                    style="
                      -webkit-user-select: none;
                      user-select: none;
                      display: inline-block;
                      position: absolute;
                      height: 90px;
                      line-height: 90px;
                      left: 135px;
                      top: 50px;
                      font-size: 80px;
                      font-family: '黑体';
                      color: #cccccc;
                    "
                  >
                    +
                  </span>
                  <span
                    ref="postfileExp"
                    style="
                      -webkit-user-select: none;
                      user-select: none;
                      display: inline-block;
                      position: absolute;
                      height: 40px;
                      line-height: 40px;
                      left: 95px;
                      top: 120px;
                      font-size: 30px;
                      font-family: '黑体';
                      color: #409eff;
                    "
                  >
                    执业证书</span
                  >
                  <img
                    ref="postfileImg"
                    style="display: none"
                    :src="postfileView"
                  />
                </div>
                <div ref="postfileDelete" class="delete-img">
                  <i class="el-icon-delete" @click="deleteImg('postfile')"></i>
                </div>
              </div>
              <input
                type="file"
                ref="postfileFile"
                style="display: none"
                @change="avatarUploadFile('postfile')"
              />
            </div>
          </div>
          <div class="form-item">
            <el-form-item label="外语能力" prop="foreignlang">
              <el-input
                v-model="personForm.foreignlang"
                :maxlength="120"
              ></el-input>
            </el-form-item>
            <el-form-item label="计算机水平" prop="compskill">
              <el-input
                v-model="personForm.compskill"
                :maxlength="120"
              ></el-input>
            </el-form-item>
          </div>

          <div class="form-item">
            <el-form-item label="其他" style="width: 960px" prop="otherinfo">
              <el-input
                type="textarea"
                :rows="2"
                v-model="personForm.otherinfo"
                style="width: 850px"
                :maxlength="120"
                showWordLimit
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
// import { dictData } from '../request/resumeApi';
import { avatarUpload, avatarDownloadBase64 } from "../request/api";
import {
  idcardAge,
  idcardSex,
  idcardBirthday,
  idcardVerify,
} from "../../utils/idcard";
import avatar_default_preview from "../../assets/avatar_default_preview2.png";

import { queryUser } from "../request/regAndEdit";
import { getLoginUser } from "../../utils/auth";
import { mapActions } from "vuex";

import { ValidateFormIdNum, ValidateFormPhone } from "../../utils/tools";

// import SelectTree from '../../components/widget/SelectTree';

export default {
  // components: {
  //     SelectTree
  // },
  props: {
    VOStatus: {
      type: String,
      default: () => {
        return "view";
      },
    },
    personData: {
      type: Object,
      default() {
        return {};
      },
    },
    avatarUploadParams: {
      type: Object,
      default() {
        return {
          isWeb: "true",
          isYES2: "true",
          mode: "1",
          service: "UploadAttachment",
          cmd: "UploadResumeImage",
          formKey: "MyResumeLib",
          oid: "-1",
          deleteOld: "1",
        };
      },
    },
  },
  data() {
    var nationValidator = (rule, value, callback) => {
      if (value === null || value === "" || value === 0) {
        callback(new Error("请选择民族"));
      } else {
        callback();
      }
    };
    var polityValidator = (rule, value, callback) => {
      if (value === null || value === "" || value === 0) {
        callback(new Error("请选择政治面貌"));
      } else {
        callback();
      }
    };
    var eduValidator = (rule, value, callback) => {
      if (value === null || value === "" || value === 0) {
        callback(new Error("请选择最高学历"));
      } else {
        callback();
      }
    };
    var hometownValidator = (rule, value, callback) => {
      if (value === null || value === "" || value === 0) {
        callback(new Error("请选择籍贯"));
      } else {
        callback();
      }
    };
    return {
      avatarUploadPreview: avatar_default_preview,
      personForm: {
        oid: 0,
        photo: "",
        name: "",
        age: "",
        education: "",
        eduno: "",
        otherinfo: "",
        formername: "",
        sex: "",
        national: "",
        hometown: "",
        birthaddr: "",
        polity: "",
        birthdate: "",
        id: "",
        partytime: "",
        health: "",
        worktime: "",
        workaddr: "",
        workdate: "",
        workcorp: "",
        workpost: "",
        schoolscore: "",
        iscoursefail: "",
        specskill: "",
        email: "",
        tel: "",
        isobey: "",
        skilllevel: 0,
        techtitle: "",
        gradetime: "",
        titletime: "",
        certitime: "",
        gradeno: "",
        titleno: "",
        certino: "",
        foreignlang: "",
        postcerti: "",
        compskill: "",
        resumecompl: 0,
        idfile: "",
        idbackfile: "",
        postfile: "",
        titlefile: "",
        gradefile: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名!", trigger: "blur" }],
        sex: [
          {
            required: true,
            message: "请选择性别!",
            trigger: "change",
          },
        ],
        national: [
          { validator: nationValidator, required: true, trigger: "blur" },
        ],
        id: [
          {
            required: true,
            validator: ValidateFormIdNum,
            trigger: "blur",
          },
        ],
        birthdate: [
          {
            required: true,
            message: "请填写出生日期!",
            trigger: "blur",
          },
        ],
        hometown: [
          { validator: hometownValidator, required: true, trigger: "blur" },
        ],
        polity: [
          {
            validator: polityValidator,
            required: true,
            trigger: "blur",
          },
        ],
        isobey: [
          {
            required: true,
            message: "请选择是否服从调剂!",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请填写电子邮箱!",
            trigger: "blur",
          },
        ],
        tel: [
          {
            required: true,
            validator: ValidateFormPhone,
            trigger: "blur",
          },
        ],
        age: [{ required: true, message: "请填入年龄!", trigger: "blur" }],
        education: [
          {
            validator: eduValidator,
            required: true,
            trigger: "blur",
          },
        ],
        eduno: [
          {
            required: true,
            message: "请输入证件编号!",
            trigger: "blur",
          },
        ],
        gradetime: [
          {
            required: true,
            message: "请选择技术技能等级取得时间!",
            trigger: "blur",
          },
        ],
        titletime: [
          {
            required: true,
            message: "请选择专业职称取得时间!",
            trigger: "blur",
          },
        ],
        certitime: [
          {
            required: true,
            message: "请选择职业资格取得时间!",
            trigger: "blur",
          },
        ],
        gradeno: [
          {
            required: true,
            message: "请输入技术技能等级批准文号!",
            trigger: "blur",
          },
        ],
        titleno: [
          {
            required: true,
            message: "请输入专业职称批准文号!",
            trigger: "blur",
          },
        ],
        certino: [
          {
            required: true,
            message: "请输入执业资格证书编号!",
            trigger: "blur",
          },
        ],
      },
      personFormData: {},
      nationList: [],
      homeDownList: [],
      homeDownData: [],
      polityList: [],
      healthList: [],
      eduList: [],
      skilllevelList: [],
      idfileView: "",
      idbackfileView: "",
      gradefileView: "",
      postfileView: "",
      titlefileView: "",
    };
  },
  methods: {
    ...mapActions(["globalDictDataRequest"]), //字段是否必输
    isEdunoEnable(dictOid) {
      let ridx = this.eduList.findIndex(
        (item) => item.oid === dictOid && item.code.startsWith("Q")
      );
      return ridx === -1 ? false : true;
    },
    //字段是否必输
    isFieldEnable(type, data) {
      if (type == "techgradetime" || type == "techgradeno") {
        let skilllevelres = data;
        if (skilllevelres && skilllevelres > 0) {
          return true;
        }
      } else if (type == "techtitletime" || type == "techtitleno") {
        let techtitleres = data;
        if (techtitleres && techtitleres.length > 0) {
          return true;
        }
      } else if (type == "postcertitime" || type == "postcertino") {
        let postcertires = data;
        if (postcertires && postcertires.length > 0) {
          return true;
        }
      }
      return false;
    },
    // 鼠标移入图片
    mouseoverImg(colname) {
      if (this.isDisabled) {
        return;
      }
      if (this.personForm[colname] != "" && this.personForm[colname] != null) {
        this.$refs[colname + "Delete"].style.display = "block";
      }
    },
    // 鼠标移出图片
    mouseoutImg(colname) {
      if (this.isDisabled) {
        return;
      }
      this.$refs[colname + "Delete"].style.display = "none";
    },
    // 删除图片
    deleteImg(colname) {
      this.$confirm("是否删除该照片?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.personForm[colname] = "";
          this.$refs[colname + "Img"].style.display = "none";
          this.$refs[colname + "Delete"].style.display = "none";
          this.$refs[colname + "Exp"].style.display = "block";
          this.$refs[colname + "Add"].style.display = "block";
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    setDefaultInfo(newVO) {
      if (this.$props.VOStatus == "new" || newVO == "new") {
        let user = getLoginUser();
        if (user) {
          var params = {
            username: user["userName"],
          };
          queryUser(params).then((res) => {
            if (res.success) {
              // res.data
              this.personForm.name = res.data.name || "";
              this.personForm.id = res.data.id || "";
              // this.personForm.titleficate = res.data.credtype || '';
              this.personForm.email = res.data.email || "";
              this.personForm.tel = res.data.telphone || "";

              this.personForm_id_input(res.data.id);
            }
          });
        }
      }
    },
    avatarUpload(colname) {
      if (this.isDisabled) {
        return;
      }
      // this.$refs.avatarFile.click();
      this.$refs[colname + "File"].click();
    },
    avatarUploadFile(colname) {
      if (!this.$refs[colname + "File"].files) {
        return;
      }
      let avatarFile = this.$refs[colname + "File"].files[0];

      //如果包含有"/"号 从最后一个"/"号+1的位置开始截取字符串
      let fileType = avatarFile.name
        .substring(avatarFile.name.lastIndexOf(".") + 1, avatarFile.name.length)
        .toUpperCase();
      if (!this.beforeAvatarUpload(fileType)) {
        return;
      }
      //图片大小校验
      let filesize = (avatarFile.size / 1024).toFixed(2);
      if (filesize > 600) {
        this.$message.error("图片大小不能超过600KB!");
        return;
      }
      let formData = new FormData();
      formData.append("file", avatarFile);

      for (let item in this.avatarUploadParams) {
        formData.append(item, this.avatarUploadParams[item]);
      }

      avatarUpload(formData).then((res) => {
        if (res.data && res.data.Name == -1) {
            this.$message.error(res.data.Message);
              return;
        }
        // 设置图片
        this.personForm[colname] = res.data.Path;
        if (res.data.Path && res.data.Path != null) {
          // 根据图片显示
          avatarDownloadBase64(res.data.Path).then((img) => {
            if (colname == "photo") {
              this.avatarUploadPreview = img.data;
            } else {
              if (img.data) {
                this[colname + "View"] = img.data;
                this.$refs[colname + "Img"].style.display = "block";
                this.$refs[colname + "Exp"].style.display = "none";
                this.$refs[colname + "Add"].style.display = "none";
              }
            }
          });
        }
      });
    },
    clearFormData() {
      // 重置数据
      this.$refs["personForm"].resetFields();

      this.setDefaultInfo();
    },
    resetFormData() {
      // 重置数据
      this.$refs["personForm"].resetFields();
      this.setDefaultInfo();
    },
    formAllValidate() {
      // 表单验证
      return new Promise(
        function (resolve) {
          this.$refs.personForm.validate((valid) => {
            if (valid) {
              // 判断照片是否上传
              if (!this.personForm.photo || this.personForm.photo == "") {
                resolve({
                  type: "personForm",
                  status: "fail",
                  msg: "请上传照片!",
                });
                return;
              }
              // 判断身份证正面是否上传
              if (!this.personForm.idfile || this.personForm.idfile == "") {
                resolve({
                  type: "personForm",
                  status: "fail",
                  msg: "请上传身份证正面!",
                });
                return;
              }
              // 判断身份证反面是否上传
              if (
                !this.personForm.idbackfile ||
                this.personForm.idbackfile == ""
              ) {
                resolve({
                  type: "personForm",
                  status: "fail",
                  msg: "请上传身份证反面!",
                });
                return;
              }
              //判断是否需要上传技能等级证书（只要有值则不能为空）
              let skilllevelres = this.personForm.skilllevel;
              if (skilllevelres && skilllevelres > 0) {
                if (
                  !this.personForm.gradefile ||
                  this.personForm.gradefile == ""
                ) {
                  resolve({
                    type: "personForm",
                    status: "fail",
                    msg: "请上传技术技能等级附件!",
                  });
                  return;
                }
              }
              //判断是否需要上传职称证书(只有W的情况不需要上传，其他都需要)
              let techtitleres = this.personForm.techtitle;
              if (techtitleres && techtitleres.length > 0) {
                if (
                  !this.personForm.titlefile ||
                  this.personForm.titlefile == ""
                ) {
                  resolve({
                    type: "personForm",
                    status: "fail",
                    msg: "请上传职称证书附件!",
                  });
                  return;
                }
              }
              //判断是否需要职业资格证书
              let postcertires = this.personForm.postcerti;
              if (postcertires != null && postcertires.length > 0) {
                if (
                  !this.personForm.postfile ||
                  this.personForm.postfile == ""
                ) {
                  resolve({
                    type: "personForm",
                    status: "fail",
                    msg: "请上传执业资格证书附件!",
                  });
                  return;
                }
              }
              resolve({
                type: "personForm",
                status: "ok",
                msg: "验证通过",
              });
            } else {
              resolve({
                type: "personForm",
                status: "fail",
                msg: "【个人信息】页签验证不通过",
              });
            }
          });
        }.bind(this)
      );
    },
    formGetValue() {
      // 页面获取值
      return this.personForm;
    },
    setFormDatas(datas) {
      // 设置数据
      if (datas) {
        for (let k in this.personForm) {
          if (datas[k]) {
            if (
              k == "photo" ||
              k == "idfile" ||
              k == "idbackfile" ||
              k == "postfile" ||
              k == "titlefile" ||
              k == "gradefile"
            ) {
              this.personForm[k] = datas[k].key;

              // 根据图片显示
              avatarDownloadBase64(datas[k].key).then((img) => {
                if (k == "photo") {
                  this.avatarUploadPreview = img.data;
                }
                if (img.data) {
                  this[k + "View"] = img.data;
                  this.$refs[k + "Img"].style.display = "block";
                  this.$refs[k + "Exp"].style.display = "none";
                  this.$refs[k + "Add"].style.display = "none";
                }
              });
            } else if (k == "hometown") {
              this.personForm[k] = datas[k].key;
            } else {
              this.personForm[k] = datas[k].key;
            }
          }
        }
      }
    },
    //获取字典
    dictData(type, list, isBlank) {
      // let data = {
      //   type: type
      // }
      // dictData(data, isBlank).then(res => {
      //   this[list] = res.data
      //   return res;
      // });

      return this.globalDictDataRequest({
        key: type,
        cacheName: list,
      }).then((res) => {
        // 深拷贝数据
        let data = [...res].map((item) => {
          return { ...item };
        });
        if (isBlank) {
          data.unshift({
            name: "请选择...",
            code: "0",
            oid: 0,
          });
        }
        this[list] = data;
        return res;
      });
    },
    //籍贯数据处理
    initData(data) {
      //console.log(data);
      let arrList = [];
      data.forEach((item) => {
        //console.log(item)
        if (item.parentid == 0) {
          let obj = {
            value: item.oid,
            label: item.name,
            code: item.code,
            parentid: item.parentid,
          };
          arrList.push(obj);
        }
      });
      arrList.forEach((ele) => {
        ele.children = this.qaq(ele.value, data);
        ele.children.forEach((ele1) => {
          ele1.children = this.qaq(ele1.value, data);
        });
      });
      // console.log(arrList);
      this.homeDownData = arrList;
    },
    qaq(id, data) {
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        if (id == data[i].parentid) {
          arr.push({
            value: data[i].oid,
            label: data[i].name,
            code: data[i].code,
            parentid: data[i].parentid,
          });
        }
      }
      return arr;
    },
    //验证
    // validForm() {
    //   this.$refs['personForm'].validate(valid => {
    //     if (valid) {
    //       console.log(123);
    //     } else {
    //       return false
    //     }
    //   })
    // },
    //  表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    personForm_id_input: function (idcard) {
      if (!idcardVerify(idcard)) {
        return;
      }

      // 获取生日
      var birthday = idcardBirthday(idcard);
      this.personForm.birthdate = birthday || "";
      // 性别
      var sex = idcardSex(idcard);
      this.personForm.sex = sex || "";

      // 年龄
      var age = idcardAge(idcard);
      this.personForm.age = age || "";
    },
    beforeAvatarUpload(type) {
      const isJPEG = type === "JPEG";
      const isJPG = type === "JPG";
      const isBMP = type === "BMP";
      const isPNG = type === "PNG";
      const isGIF = type === "GIF";

      if (!isJPEG && !isJPG && !isBMP && !isPNG && !isGIF) {
        this.$message.error(
          "格式错误，上传图片只能是 JPG、BMP、GIF、PNG、JPEG 格式!"
        );
        return false;
      } else return true;
    },
  },
  mounted() {
    // 设置默认值
    this.setDefaultInfo();

    for (let i in this.personData) {
      for (let k in this.personForm) {
        if (i == k) {
          this.personForm[k] = this.personData[i].value;
        }
      }
    }
    this.dictData("bd_national", "nationList", true);
    this.dictData("bd_hometown", "homeDownList").then((res) => {
      // 处理籍贯
      this.initData(res);
    });
    this.dictData("bd_polity", "polityList", true);
    // 学历
    this.dictData("bd_commonedu", "eduList", true);

    this.dictData("bd_health", "healthList", true);

    this.dictData("bd_skilllevel", "skilllevelList", true);
  },
  computed: {
    isDisabled: function () {
      if (this.$props.VOStatus == "view") {
        return true;
      } else if (this.$props.VOStatus == "edit") {
        return false;
      } else if (this.$props.VOStatus == "new") {
        return false;
      }
      return true;
    },
  },
  watch: {
    "$props.VOStatus": function (newVal) {
      console.log(newVal);
      this.setDefaultInfo(newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
.person-wrap {
  padding-left: 16px;
  padding-right: 0;
}

.person-wraper {
  .el-form-item {
    width: 310px;
  }

  .el-select {
    width: 210px;
    // margin-right: 10px;
  }

  .el-date-editor {
    width: 210px;
  }

  .el-cascader {
    width: 210px;
  }

  .el-input {
    width: 210px;
  }
}

.person-form-photo {
  position: relative;
  height: 226px;
  margin-bottom: 20px;

  .left-content {
    // 左侧区域
    margin-right: 320px;
  }

  // 右侧图片区域
  .right-avatar {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 10px;
    width: 310px;
    height: 226px;
    background: #eee;

    // border-radius: 12px;
    padding: 12px;

    .el-button {
      border: none;
      border-radius: 0px;
    }
  }

  .right-avatar-wrap {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .avatar-wrap {
    display: inline-block;
    width: 200px;
    height: 100%;
    position: relative;
    border-radius: 12px;
    background: #fff;

    img {
      display: block;
      height: 100%;
      width: 100%;
      border-radius: 12px;
    }
  }

  .option {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
    text-align: right;

    // .el-button {}
  }
}

.resume-img {
  float: left;
  width: 294px;
  height: 206px;
  background-color: #f5f7f9;
  margin-left: 21px;
  bottom: 10px;
  overflow: hidden;
  position: relative;

  .imgcontent {
    height: 100%;
  }

  .imgspan {
    height: 100%;
    display: flex;
    text-align: center;
    vertical-align: middle;
    align-items: center;
  }

  .delete-img {
    display: none;
    position: absolute;
    width: 294px;
    height: 30px;
    line-height: 30px;
    bottom: 1px;
    background: rgba(59, 60, 61, 0.5);
    z-index: 999;
    cursor: pointer;
    text-align: right;

    i {
      margin: 8px 10px 0 0;
      display: relative;
      font-size: 14px;
      color: white;
    }
  }

  img {
    width: auto;
    height: auto;
    max-width: 350px;
    max-height: 206px;
    margin: 0 auto;
  }
}

.upload-img-form {
  z-index: 20;
}

.showimg {
  position: absolute;
  width: 184px;
  height: 220px;
  right: 70px;
  top: 40px;
  z-index: 10;
}

.person-dialog {
  position: relative;

  .person-form {
    margin-left: 40px;
    width: 965px;

    .upload-img-form {
      width: 184px;
      height: 220px;
      position: absolute;
      right: 60px;
      top: 40px;
      border: 1px solid #f3f3f3;
      border-radius: 6px;
      cursor: pointer;
      text-align: center;

      ::v-deep .el-form-item__content {
        margin-top: 80px;
      }
    }
  }
}
</style>
